import PropTypes from 'prop-types';

const headerSize = 60;
export const menuBreakpoint = 1280;

export const headerSizes = {
  HEADER: headerSize,
  MAIN_HEADER_PADDING: 12,
  LOGO_WIDTH: 150,
  LOGO_MARGIN: 24,
  GROUP_PADDING: 24,
  SUBLINK_PADDING: 8,
  BURGER_HEADER_MARGIN: 60
};

export const groupPropTypes = PropTypes.shape({
  name: PropTypes.string.isRequired,
  pages: PropTypes.arrayOf(PropTypes.shape({
    links: PropTypes.arrayOf(PropTypes.shape({
      pack: PropTypes.string.isRequired,
      link: PropTypes.string,
    })).isRequired,
    title: PropTypes.string.isRequired,
    hasAccess: PropTypes.bool.isRequired,
  }))
});
